/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "TextInputFieldContentType": {
                    "values": {
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_DEFERRED": 0,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_URL": 1,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_NAME_PREFIX": 2,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_NAME": 3,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_NAME_SUFFIX": 4,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_GIVEN_NAME": 5,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_MIDDLE_NAME": 6,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_FAMILY_NAME": 7,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_NICKNAME": 8,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_GENDER": 9,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_ORGANIZATION_NAME": 10,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_JOB_TITLE": 11,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_LOCATION": 12,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_FULL_STREET_ADDRESS": 13,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_STREET_ADDRESS_LINE1": 14,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_STREET_ADDRESS_LINE2": 15,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_ADDRESS_LOCALITY": 16,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_ADDRESS_LOCALITY_AND_REGION": 17,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_ADDRESS_REGION": 18,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_POSTAL_CODE": 19,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_POSTAL_CODE_EXTENDED": 20,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_SUBLOCALITY": 21,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_COUNTRY_NAME": 22,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_USERNAME": 23,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_PASSWORD": 24,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_NEW_PASSWORD": 25,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_ONE_TIME_CODE": 26,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_EMAIL_ADDRESS": 27,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_TELEPHONE_NUMBER": 28,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_NUMBER": 29,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_EXPIRATION": 30,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_EXPIRATION_MONTH": 31,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_EXPIRATION_YEAR": 32,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_SECURITY_CODE": 33,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_TYPE": 34,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_NAME": 35,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_GIVEN_NAME": 36,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_MIDDLE_NAME": 37,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_CREDIT_CARD_FAMILY_NAME": 38,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_BIRTHDATE": 39,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_BIRTHDATE_DAY": 40,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_BIRTHDATE_MONTH": 41,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_BIRTHDATE_YEAR": 42,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_DATE_TIME": 43,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_FLIGHT_NUMBER": 44,
                      "TEXT_INPUT_FIELD_CONTENT_TYPE_SHIPMENT_TRACKING_NUMBER": 45
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.TextInputFieldContentType) {
  $root.addJSON(jsonData);
}

/**
 * Specifies the semantic meaning of the inputted text.
 * The system then uses this value to improve autocomplete, show autofill suggestions, etc.
 * These typically correspond to UITextContentType from iOS.
 *
 * SOURCE TextInputFieldContentType @ squareup/bbfrontend/common/component/text_input_field_content_type.proto at 14:1
 */
export const TextInputFieldContentType = $root.lookupEnum('squareup.bbfrontend.common.component.TextInputFieldContentType').values;